import {
    getDocs,
    collection,
    // doc,
    updateDoc,
    limit,
    orderBy,
    getCountFromServer,
    // getDoc,
    // startAt,
    // setDoc,
    query,
    where,
    addDoc,
    startAfter,
    deleteDoc,
    doc
} from 'firebase/firestore'
import { db } from '../firebase'
export default class Banner {
    constructor() {
        this.KEY = 'Banner'
    }
    async allBanners(l = 10, p = 0) {
        try {
            const start = parseInt(l) * parseInt(p);
            const startDocSnap = start > 0 ? await getDocs(
                query(
                    collection(db, this.KEY),
                    where('id', '==', start - 1),
                    orderBy('id'),
                    limit(1)
                )
            ) : null;
            const startDoc = startDocSnap?.docs?.[startDocSnap?.docs?.length - 1]
            let data = []
            const querySnapshot = await getDocs(
                !startDoc ? query(
                    collection(db, this.KEY),
                    orderBy('id'),
                    limit(l))
                    : query(
                        collection(db, this.KEY),
                        orderBy('id'),
                        startAfter(startDoc),
                        limit(l)));
            console.log(querySnapshot)
            querySnapshot.forEach((doc) => {
                console.log(doc.id, " => ", doc.data());
                data.push({ ...doc.data(), id: doc.id })
            });
            return data
        } catch (error) {
            console.error(error);
            return []
        }
    }
    async addBanner(params) {
        try {
            if (params.id) {
                const docRef = query(collection(db, this.KEY), where('id', '==', params.id))
                return await updateDoc(docRef, params)
            }
            const id = (await getCountFromServer(collection(db, this.KEY))).data().count
            return await (await addDoc(
                collection(db, this.KEY), { ...params, id })
            )
        } catch (error) {
            console.error(error, params)
        }
    }
    async deleteBanner(params) {
        try {
            const docRef = doc(db, this.KEY, params.id)
            return await deleteDoc(docRef)
        } catch (error) {
            console.error(error, params)
        }
    }
}